var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPanTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3309_27581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3332 3.66667V13.3333C15.3332 14.8 14.1332 16 12.6665 16H7.79984C7.07984 16 6.39984 15.7133 5.89984 15.2067L0.666504 9.88667C0.666504 9.88667 1.5065 9.06667 1.53317 9.05333C1.67984 8.92667 1.85984 8.86 2.05984 8.86C2.2065 8.86 2.33984 8.9 2.45984 8.96667C2.4865 8.97333 5.33317 10.6067 5.33317 10.6067V2.66667C5.33317 2.11333 5.77984 1.66667 6.33317 1.66667C6.8865 1.66667 7.33317 2.11333 7.33317 2.66667V7.33333H7.99984V1C7.99984 0.446667 8.4465 0 8.99984 0C9.55317 0 9.99984 0.446667 9.99984 1V7.33333H10.6665V1.66667C10.6665 1.11333 11.1132 0.666667 11.6665 0.666667C12.2198 0.666667 12.6665 1.11333 12.6665 1.66667V7.33333H13.3332V3.66667C13.3332 3.11333 13.7798 2.66667 14.3332 2.66667C14.8865 2.66667 15.3332 3.11333 15.3332 3.66667Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanTool);
export default __webpack_public_path__ + "static/media/pan_tool.19b4bf3f2a362fe7c70cb0a45081d931.svg";
export { ForwardRef as ReactComponent };